import { render, staticRenderFns } from "./ChaptersBar.vue?vue&type=template&id=392f97a8&scoped=true&"
import script from "./ChaptersBar.vue?vue&type=script&lang=js&"
export * from "./ChaptersBar.vue?vue&type=script&lang=js&"
import style0 from "./ChaptersBar.vue?vue&type=style&index=0&id=392f97a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392f97a8",
  null
  
)

export default component.exports